import LREventSubmission from "./LegacyRouteComponents/LREventSubmission";
import LREventCalendar from "./LegacyRouteComponents/LREventCalendar";
import LRRankings from "./LegacyRouteComponents/LRRankings";
import Home from "../pages/home/Home";

export const legacyRoutes = () => {
  return [
    { path: "index.php", element: <Home /> },
    {
      path: "circuit-event-submission.php",
      element: <LREventSubmission />,
    },
    {
      path: "circuit-calendar.php",
      element: <LREventCalendar />,
    },
    {
      path: "circuit-rankings.php",
      element: <LRRankings />,
    },
  ];
};
